import thumbsUp from "../assets/icons/thumbs-icon.svg";
import paragraphIcon from "../assets/icons/paragraph-icon.svg";
import forwardIconBtn from "../assets/icons/forward-icon.svg";
import backwardIconBtn from "../assets/icons/backward-icon.svg";
import arrowIcon from "../assets/icons/arrows.svg";
import lightArrowIcon from "../assets/icons/light-arrow.svg";
import textIcon from "../assets/icons/text-icon.svg";
import whiteTextIcon from "../assets/icons/white-text-icon.svg"
import quoteAltLeftIcon from "../assets/icons/quote-alt-left-icon.svg"
import navIcon from "../assets/icons/nav-icon.svg"




export const useExport = () => {
  return {
    thumbsUp,
    paragraphIcon,
    forwardIconBtn,
    backwardIconBtn,
    arrowIcon,
    lightArrowIcon,
    textIcon,
    whiteTextIcon,
    quoteAltLeftIcon,
    navIcon
  };
};
